var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 64,
    viewBox: "0 0 86 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9875 10.6667H46.1685C46.1685 10.6667 43.8202 46.019 32.0781 46.019C26.342 46.019 22.8476 37.5827 20.7736 28.9523C18.6019 19.9159 17.9875 10.6667 17.9875 10.6667Z",
    stroke: "#78350F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1685 10.6667C46.1685 10.6667 48.625 8.04623 50.6666 7.99999C54.6666 7.90943 55.4061 10.6667 55.4061 10.6667C56.189 12.2921 56.8151 16.5181 53.0578 20.4191C49.3002 24.32 45.0941 27.7333 43.3823 28.9523",
    stroke: "#78350F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9873 10.6667C17.9873 10.6667 15.4278 8.01637 13.3331 8.00002C9.33309 7.9688 8.59359 10.6667 8.59359 10.6667C7.81077 12.2921 7.18453 16.5181 10.942 20.4191C14.6995 24.32 19.0618 27.7333 20.7733 28.9525",
    stroke: "#78350F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6843 53.3334C22.6843 48.4572 32.0779 46.019 32.0779 46.019C32.0779 46.019 41.4717 48.4572 41.4717 53.3334H22.6843Z",
    stroke: "#78350F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1421 1.42651C30.2331 1.42651 25.7714 12.1979 32.0711 18.4976L50.3553 36.7819C54.2606 40.6871 60.5922 40.6871 64.4975 36.7819L82.7817 18.4976C89.0814 12.1979 84.6197 1.42651 75.7107 1.42651H39.1421Z",
    fill: "#0369A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupIcon);
export default __webpack_public_path__ + "static/media/cup_icon.c2536af6f4f5e55adfa1e936209ff000.svg";
export { ForwardRef as ReactComponent };